/** The storage token for accessing cached authentication. */
export const storageKey = 'authentication'

/** The expected time, in minutes, of inactivity before a given token is expected to be invalid. */
export const expectedTokenExpiry = 30